module.exports = __webpack_public_path__ + "static/media/c.e13c3918.svg";